import { useState } from "react";
import { loginUser, registerUser } from "../firebase";

const fld = {
  background:"#F8F9FA", borderRadius:10, padding:"12px 14px",
  color:"#202124", fontSize:14, fontFamily:"inherit",
  border:"1px solid #DADCE0", width:"100%", outline:"none",
};

function friendlyError(code = "") {
  if (code.includes("user-not-found") || code.includes("invalid-credential")) return "No account found with this email or password.";
  if (code.includes("wrong-password"))    return "Incorrect password.";
  if (code.includes("email-already"))     return "An account with this email already exists.";
  if (code.includes("invalid-email"))     return "Please enter a valid email address.";
  if (code.includes("too-many-requests")) return "Too many attempts. Please try again later.";
  if (code.includes("weak-password"))     return "Password must be at least 6 characters.";
  return "Something went wrong. Please try again.";
}

export default function LoginScreen() {
  const [mode,    setMode]    = useState("login");
  const [email,   setEmail]   = useState("");
  const [pw,      setPw]      = useState("");
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email.trim() || !pw) return;
    setError(""); setLoading(true);
    try {
      mode === "login"
        ? await loginUser(email.trim(), pw)
        : await registerUser(email.trim(), pw);
    } catch (e) {
      setError(friendlyError(e.code || e.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:"100vh",
      background:"linear-gradient(155deg,#E8F0FE 0%,#F8F9FB 60%)",
      display:"flex", alignItems:"center", justifyContent:"center",
      padding:24, fontFamily:"'Google Sans','Roboto',sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Google+Sans:wght@400;500;700&family=Roboto:wght@400;500;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        input::placeholder{color:#9AA0A6}
        button{font-family:inherit;cursor:pointer}
      `}</style>

      <div style={{background:"#fff",borderRadius:22,padding:"36px 28px",width:"100%",maxWidth:380,boxShadow:"0 4px 32px rgba(66,133,244,0.13)"}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:48,marginBottom:8}}>✅</div>
          <div style={{fontSize:24,fontWeight:700,color:"#202124"}}>Habit Tracker</div>
          <div style={{fontSize:13,color:"#9AA0A6",marginTop:4}}>Build better habits, every day</div>
        </div>

        {/* Mode toggle */}
        <div style={{display:"flex",background:"#F1F3F4",borderRadius:12,padding:3,marginBottom:22,gap:2}}>
          {[["login","Sign In"],["register","Create Account"]].map(([m,label]) => (
            <button key={m} onClick={()=>{setMode(m);setError("");}} style={{
              flex:1, padding:"9px 6px", borderRadius:9, border:"none",
              fontWeight:600, fontSize:13, transition:"all 0.17s ease",
              background: mode===m ? "#4285F4" : "transparent",
              color: mode===m ? "#fff" : "#9AA0A6",
              boxShadow: mode===m ? "0 2px 6px rgba(66,133,244,0.28)" : "none",
            }}>{label}</button>
          ))}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <input type="email" placeholder="Email address"
            value={email} onChange={e=>setEmail(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&submit()} style={fld} autoFocus />
          <input type="password" placeholder="Password (min 6 characters)"
            value={pw} onChange={e=>setPw(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&submit()} style={fld} />

          {error && (
            <div style={{background:"#FCECEA",border:"1px solid #FFCDD2",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#C62828"}}>
              ⚠️ {error}
            </div>
          )}

          <button onClick={submit} disabled={loading || !email || !pw} style={{
            background: (loading||!email||!pw) ? "#E8EAED" : "#4285F4",
            color:      (loading||!email||!pw) ? "#9AA0A6" : "#fff",
            border:"none", borderRadius:12, padding:"14px",
            fontSize:15, fontWeight:700,
            boxShadow: (loading||!email||!pw) ? "none" : "0 2px 10px rgba(66,133,244,0.3)",
            transition:"all 0.17s ease",
          }}>
            {loading ? "Please wait…" : mode === "login" ? "Sign In →" : "Create Account →"}
          </button>
        </div>

        <div style={{textAlign:"center",marginTop:18,fontSize:12,color:"#9AA0A6"}}>
          {mode === "login"
            ? <>No account? <button onClick={()=>setMode("register")} style={{background:"none",border:"none",color:"#4285F4",fontWeight:600,fontSize:12}}>Create one free</button></>
            : <>Have an account? <button onClick={()=>setMode("login")} style={{background:"none",border:"none",color:"#4285F4",fontWeight:600,fontSize:12}}>Sign in</button></>
          }
        </div>
      </div>
    </div>
  );
}
